import "../styles/aboutus.css";
import { useLocation } from "react-router-dom";

function AboutUs() {
  const location = useLocation();
  const { aData } = location.state || {};
  return (
    <div className="about-container">
      <img
        src={`${process.env.PUBLIC_URL}/logo.png`}
        alt="Trekkers Clan Logo"
        className="about-logo"
      />
      {/* <h1>About Us</h1> */}
      <p dangerouslySetInnerHTML={{ __html: aData || "" }}></p>
    </div>
  );
}

export default AboutUs;
